import type {InterfaceStrings} from './strings'

export const de: InterfaceStrings = {
    nav: {
        beginSession: 'Sitzung starten',
        faq: 'FAQ',
        pricing: 'Preise',
        legal: 'Impressum',
        signIn: 'Anmelden',
        viewPricing: 'Preise ansehen',
        signOut: 'Abmelden',
        account: 'Konto',
        menu: 'Menü',
        closeMenu: 'Menü schließen',
        mainNav: 'Hauptnavigation',
        sessions: {one: '{n} Sitzung', other: '{n} Sitzungen'},
    },
    footer: {
        selfHypnosisFor: 'Selbsthypnose bei',
        anxiety: 'Angst',
        sleep: 'Schlafproblemen',
        stress: 'Stress',
        confidence: 'Selbstzweifeln',
        focus: 'Konzentrationsproblemen',
        learn: 'Hintergrund',
        ericksonian: 'Was ist Ericksonsche Hypnose',
        aiHow: 'Wie KI-Hypnose funktioniert',
        vsMeditation: 'Hypnose oder Meditation',
        methods: 'Verfahren',
        languages: 'Sprachen',
    },
    page: {
        cta: 'Kostenlose Sitzung beginnen',
        hint: 'Ihre erste Sitzung ist kostenlos',
        exploreFurther: 'Weiterlesen',
        disclaimer:
            'Quies ist ein Wellness-Werkzeug zur Entspannung und Selbsterkundung. Es ist kein Medizinprodukt und diagnostiziert, behandelt oder heilt keine Erkrankung. In einer seelischen Krise wenden Sie sich bitte an eine Ärztin, einen Arzt oder eine psychotherapeutische Fachperson.',
        transcript: 'Transkript',
        transcriptNote: 'Ein Auszug aus einer echten Quies-Sitzung, so wie er gesprochen wurde.',
        breadcrumb: 'Brotkrumennavigation',
    },
    pricing: {
        selectPlan: 'Paket wählen',
        subscribe: 'Abonnieren',
        perMonth: 'pro Monat',
        manageSubscription: 'Abonnement verwalten',
        replayFree: 'Eine vergangene Sitzung erneut anzuhören ist immer kostenlos.',
        offerLead: 'Jede Sitzung beginnt dort, wo die letzte aufgehört hat.',
    },
    session: {
        chooseLanguage: 'Wählen Sie Ihre Sprache',
        changeLanguage: 'Sprache ändern',
        changeVoice: 'Stimme ändern',
        previewVoice: '{voice} anhören',
        stopPreview: 'Hörprobe beenden',
        continue: 'Weiter',
        composing: 'Quies schreibt Ihre Sitzung',
        preparing: 'Ihre Meditation wird vorbereitet',
        pickingUp: 'es geht dort weiter, wo Sie aufgehört haben',
        today: 'Heute',
        yesterday: 'Gestern',
        loading: 'Wird geladen…',
        showEarlier: 'Frühere anzeigen ({count})',
        tryDifferentApproach: 'Einen anderen Weg versuchen',
        nothingAdded: 'Nichts hinzugefügt',
        purchaseConfirmed: 'Kauf bestätigt',
        firstSessionNote: 'Ihre erste Sitzung ist kostenlos. Sie melden sich an, bevor Sie zuhören.',
    },
    threshold: {
        title: 'Melden Sie sich an, um zuzuhören',
        message: 'Ihre erste Sitzung ist kostenlos. Keine Karte nötig.',
        google: 'Weiter mit Google',
        sendLink: 'Anmeldelink an mich senden',
        sending: 'Wird gesendet…',
        emailLabel: 'E-Mail-Adresse',
        or: 'oder',
        waitingTitle: 'Prüfen Sie Ihr Postfach',
        waitingBody: 'Wir haben einen Anmeldelink an {email} gesendet.',
        sendAgain: 'Erneut senden',
        googleInstead: 'Stattdessen mit Google anmelden',
        codeLabel: 'Oder geben Sie den 6-stelligen Code aus der E-Mail ein',
        codeSubmit: 'Weiter',
        codeSubmitting: 'Wird geprüft…',
        codeWrong: 'Dieser Code ist nicht richtig.',
        codeDead: 'Dieser Code gilt nicht mehr. Nutzen Sie den Link in der E-Mail oder lassen Sie sich einen neuen senden.',
        errors: {
            invalidEmail: 'Geben Sie eine gültige E-Mail-Adresse ein.',
            rateLimited: 'Zu viele Versuche. Versuchen Sie es in einigen Minuten erneut.',
            sessionError: 'Mit Ihrer Anmeldung ist etwas schiefgegangen. Laden Sie die Seite neu und versuchen Sie es erneut.',
            sendFailed: 'Die E-Mail konnte nicht gesendet werden. Bitte versuchen Sie es erneut.',
            sessionExpired: 'Ihre Anmeldung ist abgelaufen. Laden Sie die Seite neu und versuchen Sie es erneut.',
            generic: 'Etwas ist schiefgegangen. Bitte versuchen Sie es erneut.',
        },
    },
    player: {
        play: 'Abspielen',
        pause: 'Pause',
        playAgain: 'Noch einmal hören',
        seek: 'Position',
        eyesClosed: 'Augen geschlossen',
        openEyes: 'Augen öffnen',
        paused: 'Pausiert',
        unavailable: 'Audio nicht verfügbar',
        untitled: 'Quies-Sitzung',
    },
    failure: {
        turnFailed: 'Bei uns ist etwas schiefgegangen. Ihre Antwort bleibt erhalten.',
        reconnecting: 'Verbindung wird wiederhergestellt…',
        refusalTitle: 'Nehmen wir einen anderen Weg',
        refusal: 'Auf einen Teil Ihrer Nachricht konnte nicht geantwortet werden. Formulieren Sie sie um oder senden Sie sie noch einmal.',
        openElsewhere: 'Diese Sitzung ist auch in einem anderen Fenster geöffnet.',
        serviceDown: 'Quies ist gerade nicht erreichbar. Nichts von dem, was Sie getan haben, geht verloren.',
        sessionsUsedTitle: 'Ihre Sitzungen sind aufgebraucht',
        voiceFailedTitle: 'Ihre Meditation ist geschrieben',
        voiceFailed: 'Die Stimme dazu ließ sich gerade nicht erzeugen. Nichts geht verloren, und eine neue Vertonung kostet nichts.',
        voiceStopped: 'Die Stimme ist mittendrin verstummt. Sie kann dort weitermachen, wo sie aufgehört hat.',
        streamMissing: 'Ihre Meditation ist fertig, aber sie ist auf dieser Seite nicht angekommen.',
        tapToListen: 'Zum Anhören tippen',
        fileFailed: 'Diese Aufnahme lässt sich nicht abspielen. Die Meditation kann kostenlos neu vertont werden.',
        recordingGone: 'Diese Aufnahme wird nicht mehr aufbewahrt.',
        purchaseCancelled: 'Kauf abgebrochen. Es wurde nichts berechnet.',
        purchasePending: 'Ihre Zahlung ist bestätigt. Ihre Sitzungen brauchen länger als sonst, bis sie ankommen.',
        checkoutFailed: 'Die Zahlung konnte nicht abgeschlossen werden. Es wurde nichts berechnet.',
        sessionEnded: 'Diese Sitzung ist an ihr Ende gekommen.',
        busy: 'Quies ist gerade sehr gefragt. Ihre Antwort bleibt erhalten; versuchen Sie es in einer Minute noch einmal.',
        tooLong: 'Diese Sitzung ist länger geworden, als Quies fassen kann. Sie wurde Ihnen gutgeschrieben.',
        notSaved: 'Dieser Schritt konnte nicht gespeichert werden. Versuchen Sie es noch einmal, um an dieser Stelle weiterzumachen.',
        meditationRefused:
            'Diese Meditation ließ sich nicht wie gewünscht schreiben. Formulieren Sie Ihren Wunsch um oder beginnen Sie neu: Diese Sitzung wird Ihnen gutgeschrieben.',
        meditationRefusedUncharged:
            'Diese Meditation ließ sich nicht wie gewünscht schreiben. Formulieren Sie Ihren Wunsch um oder beginnen Sie neu.',
        linkExpired: 'Ihr Anmeldelink ist abgelaufen. Fordern Sie einen neuen an.',
        oauthFailed: 'Die Anmeldung wurde unterbrochen. Bitte versuchen Sie es noch einmal.',
        offline: 'Sie sind offline. Ihre Antwort wird gesendet, sobald Sie wieder verbunden sind.',
        voiceChanged: 'Ihre Stimme ist nicht mehr verfügbar; eine andere Stimme spricht diese Meditation.',
        voiceReturned: 'Die Stimme ließ sich weiterhin nicht erzeugen. Diese Sitzung wurde Ihnen gutgeschrieben.',
        voiceFailedAgain: 'Die Stimme ließ sich weiterhin nicht erzeugen.',
        voiceResuming: 'Die Stimme setzt wieder ein…',
        voiceLimited: 'In dieser Stunde wurden schon mehrere Meditationen für Sie vertont. Versuchen Sie es etwas später noch einmal.',
        tryAgain: 'Erneut versuchen',
        rephrase: 'Umformulieren',
        resume: 'Fortsetzen',
        voiceAgain: 'Neu vertonen',
        listen: 'Anhören',
        continue: 'Weiter',
        begin: 'Sitzung beginnen',
        signIn: 'Anmelden',
        checkAgain: 'Erneut prüfen',
        sendLink: 'Anmeldelink senden',
        useEmail: 'Stattdessen E-Mail verwenden',
    },
}
